import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { CharonService, CONFIG, ENTRYPOINT, HTTPOPTIONS, IConfig } from './core';
import { CharonHttpInterceptor } from './http/src/charon.http.interceptor';
import { CharonSessionService } from './http/src/charon.http.session.service';

export function generateModuleConfig({ payloadCryptography, provider, httpOptions, entryPoint }: IConfig): Provider[] {
  const providers: Provider[] = [];

  providers.push({
    provide: CharonService,
    useClass: provider,
  });

  if (httpOptions) {
    providers.push({
      provide: HTTPOPTIONS,
      useValue: httpOptions,
    });
  }

  if (entryPoint) {
    providers.push({
      provide: ENTRYPOINT,
      useValue: entryPoint,
    });
  }

  if (payloadCryptography) {

    providers.push({
      provide: CONFIG,
      useValue: payloadCryptography,
    });

    providers.push({
      provide: HTTP_INTERCEPTORS,
      useClass: CharonHttpInterceptor,
      deps: [
        CharonSessionService
      ],
      multi: true
    });
  }

  return providers;
}
